export default __webpack_public_path__ + "static/map-535121e98c7b53a4fc608f9cfdb29cd3.png";